<script lang="ts">
    import { getContext } from "svelte";
    import { userState } from "../modules/store";
    import type { UserProcessNavigator } from "../modules/UserProcessNavigator";
    import type { ApiService } from "../services";
    const api: ApiService = getContext("api-service");
    const nav: UserProcessNavigator = getContext("navigator");
    nav.navigateToDefaultForCurrentState();
    let signingDocument: boolean=false;
    async function signhipaa() {
        signingDocument=true;
        var result = await api.StoreHipaaAsync($userState.assessment.id);
        if(result.success)
        {
            await api.CalculateResultsAsync($userState.assessment.id);
            userState.update((currentState) => {
                currentState.isHipaaSigned=true;
                currentState.hipaaSignatureDate=new Date(Date.now());
                return currentState;
            });
        }   
        signingDocument=false;     
    }



</script>

<div class="hipaadoc" id="hipaadoc" >
  <div class="content" id="content" style="color: white;">
    <h1>Authorization to Release Protected Health Information</h1>
    <ul>
      <li>
        I hereby authorize Longevity Quest, Inc. ("LongevityQuest") and
        its authorized representatives to collect any and all
        individually identifiable health information including medical
        records, reports, pharmaceutical records, drugs, diagnostic
        testing, lab work, and sensitive condition data pertaining to
        mental health, substance or alcohol use and STD's, and this
        includes information on the diagnosis or treatment of Human
        Immunodeficiency Virus (HIV);
      </li>
      <li>
        I understand that LongevityQuest and its authorized
        representatives need to collect such information in regard to
        performing services, and that such information is required for
        the purpose of performing such services;
      </li>
      <li>
        I authorize any licensed physician, medical practitioner,
        hospital, clinic, laboratory, pharmacy, pharmacy benefit
        manager, pharmacy related service organization or medically
        related facility, the Medical Information Bureau ('MIB') or
        other organization, institution or person that has knowledge or
        records of me and my health to disclose information as allowed
        or required by law;
      </li>
      <li>
        I give permission to LongevityQuest and their contractors,
        successors and assignees to perform certain laboratory and
        diagnostic tests on the fluid samples and physical measurements
        collected by a third party laboratory service provider, or to
        collect any and all individually identifiable health information
        including medical records, reports, pharmaceutical records,
        drugs, diagnostic testing, lab work, and sensitive condition
        data pertaining to mental health, substance or alcohol use and
        STD's, including HIV-related information, and to compile such
        information and use it in the context of calculating longevity
        probabilities, potential conditions and other products and
        services that may be impacted by such information;
      </li>
      <li>
        I understand that this authorization is voluntary, and I can
        refuse this authorization, and if signed is valid for twenty
        four (24) months from the date of my electronic signature below
        unless revoked in writing exclusively to Longevity Quest, Inc.,
        100 Union Hill Drive, Suite 100, Birmingham, AL 35209 and that
        such revocation will not affect the rights of any individual who
        has acted in reliance on the authorization prior to receiving
        notice of the revocation;
      </li>
      <li>
        I represent that I am eighteen (18) years of age or older if I
        am providing the necessary fluid samples and physical
        measurements or accessing my information;
      </li>
      <li>
        I am guaranteeing that any fluid samples, physical measurements,
        or other information that I provide or authorize LongevityQuest
        to collect in connection with obtaining their services, are my
        own, and if I am obtaining LongevityQuest's services on behalf
        of a person from or for whom I have legal authorization, I are
        confirming that any fluid samples, physical measurements and
        other information provided or authorized LongevityQuest to
        collect will be those of that person
      </li>
      <li>
        I understand that there is a possibility of re-disclosure of any
        information disclosed pursuant to this authorization and that
        information, once disclosed, may no longer be protected by
        federal rules governing privacy and confidentiality; and
      </li>
      <li>
        I assume responsibility for all consequences resulting from my
        sharing the content of or access to my information, including
        any laboratory results, medical records, pharmaceutical records,
        diagnostic testing and analyses.
      </li>
    </ul>
    <p>
      By my signature below, I acknowledge that any agreements I have made
      to restrict my protected health information or other personal
      confidential information do not apply to this authorization and I
      instruct my providers to release and disclose the information
      without restriction at my request as permitted by law.
    </p>
    <p>
      A copy of this authorization will be as valid as the original. I
      understand that I am entitled to receive a copy of this
      authorization. I also understand that the signing of this
      authorization is voluntary; however, if I do not sign the
      authorization, LongevityQuest may not be able to perform the
      services that I have requested be provided.
    </p>
  </div>
  <div class="sig" style="color: white;">
        <div class="col">
            <div class="data">
                {$userState.fullName}, {$userState.assessment.dateOfBirth}
            </div>
            <div class="label">Your Legal Name and Date Of Birth</div>
        </div>
        <div class="col">
            <div class="data">{$userState.assessment.email}</div>
            <div class="label">Your Email Address</div>
        </div>
        <div class="col">
            <div class="data">
                {#if $userState.isHipaaSigned}
                    <span class="sigline">{$userState.fullName}</span>
                {:else}
                    <button class="sigbutton" on:click={signhipaa}
                       disabled={signingDocument} >
                       {#if !signingDocument}
                       Affix Signature
                       {:else}
                       Recording signature...
                       {/if}
                       </button>
                {/if}
            </div>
            <div class="label">
                Signature
                {#if $userState.isHipaaSigned}
                    <span class="timestamp">
                        [Signed:{$userState.hipaaSignatureDate}]</span
                    >
                {/if}
            </div>
        </div>
        <div class="col">
            {#if $userState.isHipaaSigned}
                <div class="data">
                    {$userState.hipaaSignatureDate.toDateString()}
                </div>
            {:else}
                <div class="data">{new Date().toDateString()}</div>
            {/if}
            <div class="label">Date</div>
        </div>
    </div>
</div>
{#if $userState.isHipaaSigned}
    <button class="continue" on:click={() => { if (typeof window !== 'undefined') { window.scrollTo({ top: 0, behavior: 'smooth' }); } nav.next(); }}>Continue</button>
{/if}

<style type="scss">
    @use "../scss/forms";
    #hipaadoc {
        margin: 0 auto;
        font-size: 10pt;
        padding-bottom: 3vh;
        width: 100%;
        font-size: 1vw;
    }
    .sig {
        display: grid;
        grid-template-columns: 50% 50%;
    }
    .col {
        padding: 0 5vw;
        margin-top: 6vh;
    }
    .data {
        border-bottom: solid 2px black;
        font-style: bold;
        font-size: 1vw;
    }
    .label {
        font-style: italic;
    }
    .sigline {
        font-family: "Allison", cursive;
        font-size: 1.75vw;
    }
    ul {
        margin: 3vh auto;
        padding: 0 4vw;
    }
    li {
        text-align: left;
        padding: 0.25vh 0;
    }
    p {
        text-align: left;
        padding: 0 4vw;
    }
    .timestamp {
        font-size: x-small;
    }
    .sigbutton {
        display: inline;
        padding: 5px;
    }
    button.continue{
        display:block;
        margin:0 auto;
        margin-bottom: 2vh;
    }
    @media (max-width: 700px) {
        #hipaadoc {
            font-size: 15px;
            padding-bottom: 2vh;
        }
        .content {
            padding: 0 2vw !important;
        }
        ul, p {
            padding: 0 2vw !important;
        }
        .sig {
            grid-template-columns: 1fr;
            gap: 0.5rem;
        }
        .col {
            padding: 0 2vw;
            margin-top: 3vh;
        }
        .data {
            font-size: 1.1em;
        }
        .sigline {
            font-size: 1.3em;
        }
        h1 {
            font-size: 1.3em;
            text-align: left;
        }
    }
</style>
